import { Button, Empty, Spin } from "antd";
import dayjs from "dayjs";
import { FC, useEffect, useState } from "react";

import Breadcrumbs from "@/components/common/Breadcrumb";
import { IMAGES } from "@/constant";
import styles from "@/pages/Notification/Notification.module.css";
import { getAllNotification, notificationReadAll } from "@/services/Notification/NotificationApis";
import { NotificationItem } from "@/types/notificationService";

const NotificationPage: FC = () => {
  const [notificationListData, setNotificationListData] = useState<NotificationItem[]>([]);
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [hasMore, setHasMore] = useState(true);

  const getAllNotificationHelper = async (loadMore = false): Promise<void> => {
    try {
      setLoader(true);
      const res = await getAllNotification({ page: page, limit, event_type: "bell-notification" });
      if (loadMore) {
        setNotificationListData((prev) => [...prev, ...res.data]);
      } else {
        setNotificationListData(res.data);
      }
      setHasMore(Number(res.currentPage) < Number(res.totalPages));
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const notificationReadAllHelper = async (): Promise<void> => {
    try {
      await notificationReadAll();
    } catch (error) {
      console.error(error);
    }
  };

  const loadMoreHelper = (): void => {
    if (!hasMore) return;

    const nextPage = page + 1;
    setPage(nextPage);
    void getAllNotificationHelper(true);
  };

  useEffect(() => {
    void notificationReadAllHelper();
  }, []);

  useEffect(() => {
    void getAllNotificationHelper();
  }, []);

  return (
    <div className={styles.container}>
      <Spin spinning={loader} fullscreen />
      <div className={styles.customBreadCrumbs}>
        <Breadcrumbs items={[{ label: "Notifications" }]} />
      </div>
      <div className={styles.mainContainer}>
        {notificationListData?.length ? (
          notificationListData.map((item: NotificationItem, index: number) => (
            <div key={index} className={styles.card}>
              <div className={styles.leftSideContainer}>
                <div className={styles.notificationIcon}>
                  <img
                    src={IMAGES.NOTIFICATION_ICON}
                    alt="notification"
                    className={styles.notificationIconSize}
                  />
                </div>
                <div>
                  <p className={styles.title}>{item.notification_event_name}</p>
                  <p className={styles.notificationDescription}>
                    {item.notification_event_content}
                  </p>
                  <p className={styles.timeLable}>
                    {dayjs(item.updated_at).format("ddd, DD MMM YYYY hh:mm A")}
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <Empty />
        )}

        {hasMore ? (
          <div className={styles.button}>
            <Button className={styles.clearButton} onClick={loadMoreHelper}>
              Load More
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default NotificationPage;
